/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon16Solid = forwardRef('UiCursorAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.807 1.927c-1.153-.866-2.8-.045-2.802 1.397l-.011 9.86c-.002 1.682 2.138 2.398 3.149 1.053l2.361-3.14a.25.25 0 0 1 .2-.1l3.93.004c1.682.002 2.398-2.138 1.054-3.149L5.807 1.927Z" })));
});
